// Registro de formatos de planilla de pago masivo por banco (código de plaza SBIF).
// Cada formato es un módulo con `{ code, label, buildWorkbook, download, filename }`.
//
// Hoy solo existe Santander (037). Agregar un banco chileno = crear su módulo acá y
// registrarlo en `BANK_FORMATS`; el backend ya devuelve las filas normalizadas (cuenta,
// RUT, nombre, monto, glosa) agnósticas al banco. Si un banco pidiera columnas propias,
// se extiende el backend con esos campos por fila.
import * as santander from './santander';

export const BANK_FORMATS = {
  [santander.code]: santander,
};

export const SUPPORTED_BANK_CODES = Object.keys(BANK_FORMATS);

/** Formato del banco por su código de plaza. `null` si aún no hay generador para él. */
export function formatForBank(code) {
  return BANK_FORMATS[String(code ?? '').trim()] ?? null;
}

/** Descarga la planilla para un banco; lanza si no hay formato para ese código. */
export function downloadBankSheetFor({ code: bankCode, origin, rows, filename }) {
  const format = formatForBank(bankCode);
  if (!format) {
    throw new Error(
      `Formato de planilla de pago no disponible para el banco ${bankCode}`,
    );
  }
  format.download({ origin, rows, filename });
}
